import React from 'react'
import { useSelector } from 'react-redux'
import * as actions from 'data/redux/actions'


const getParameterByName = (name, url = window.location.href) => {

  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export const useUser = () => {

  const userId = parseInt(
      getParameterByName("simulateUser")
          ? getParameterByName("simulateUser")
          : playmotiv.user.id
  )

  // Funciones utilizadas para recuperar el detalle del juego de un jugador
  // distinto al que ha accedido al player
  const getGame = (userId, gameId) => {
    return actions._getGame(userId, gameId)
  }
  const getGameStatus = (userId, gameId) => {

    return actions._getGameStatus(userId, gameId)
  }

  return {
    userId,
    getGame,
    getGameStatus
  }
}
